<div #panelContainer class="ax-side-panel__container" [ngClass]="setClasses()">
    <ng-content></ng-content>
</div>
